// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Code } from "./Code";
import { CodeFromJSON, CodeFromJSONTyped, CodeToJSON, CodeToJSONTyped } from "./Code";

/**
 * Defaults for label and symbol will be provided if code is recognized. Follows following OGC SWE Common Data Model UnitReference specification (without the href attribute), see reference: https://docs.ogc.org/is/24-014/24-014.html#json_unitreference_obj
 * @export
 * @interface UnitOfMeasure
 */
export interface UnitOfMeasure {
  /**
   * A human readable label for the unit
   */
  label?: string | null;
  /**
   *
   */
  symbol?: string | null;
  /**
   *
   */
  code: Code;
}

/**
 * Check if a given object implements the UnitOfMeasure interface.
 */
export function instanceOfUnitOfMeasure(value: object): value is UnitOfMeasure {
  if (!("code" in value) || value["code"] === undefined) return false;
  return true;
}

export function UnitOfMeasureFromJSON(json: any): UnitOfMeasure {
  return UnitOfMeasureFromJSONTyped(json, false);
}

export function UnitOfMeasureFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitOfMeasure {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"] === undefined ? undefined : json["label"] === null ? null : json["label"],
    symbol:
      json["symbol"] === undefined ? undefined : json["symbol"] === null ? null : json["symbol"],
    code: CodeFromJSON(json["code"]),
  };
}

export function UnitOfMeasureToJSON(json: any): UnitOfMeasure {
  return UnitOfMeasureToJSONTyped(json, false);
}

export function UnitOfMeasureToJSONTyped(
  value?: UnitOfMeasure | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    symbol: value["symbol"],
    code: CodeToJSON(value["code"]),
  };
}
